import { AppConfigDTO, Completable, pending, pristine } from 'kashable-mobile-common';

import { getAppConfig as getAppConfigRequest } from '../apis/config';
import { RootState } from '../store';

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<AppConfigDTO> = pristine();

export const fetchAppConfig = createAsyncThunk('config/fetch', async (_, { rejectWithValue }) => {
    const response = await getAppConfigRequest();

    if (response.error) {
        return rejectWithValue(response);
    }

    return response;
});

export const configSlice = createSlice({
    name: 'config',
    initialState: INITIAL_STATE,
    reducers: {
        clearConfig: () => {
            return { ...INITIAL_STATE };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppConfig.pending, () => {
                return pending();
            })
            .addCase(fetchAppConfig.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const {
    clearConfig,
} = configSlice.actions;

export const selectAppConfig = (state: RootState) => state.config;

export default configSlice.reducer;
